import $ from 'jquery';

const HAS_ERROR_MODIFIER = 'block-newsletter-signup--has-error';
const SPINNER_MODIFIER = 'block-newsletter-signup--spinner';
const MESSAGE_SHOW_MODIFIER = 'block-newsletter-signup__message--show';

export default class MainNavHandler {
    constructor() {
        this.$blockNewsletterSignup = $('.block-newsletter-signup');
        if(this.$blockNewsletterSignup.length > 0){
            this.setupEvents();
        }
    }

    setupEvents() {
        this.$blockNewsletterSignup.find('.block-newsletter-signup__form').on('submit', function(e) {
            e.preventDefault();
            let $form = $(e.target);
            let $submitButton = $form.find('[type="submit"]');
            let $email = $form.find('[name="sub_email"]').val();
            this.$blockNewsletterSignup.removeClass(HAS_ERROR_MODIFIER);

            if ($.trim($email)) {
                $submitButton.prop('disabled', true);
                this.$blockNewsletterSignup.addClass(SPINNER_MODIFIER);
                let $message = this.$blockNewsletterSignup.find('.block-newsletter-signup__message');
                let args = $form.serialize();
                $message.removeClass(MESSAGE_SHOW_MODIFIER);

                $.post($form.attr('action'), args, function(data) {
                    $submitButton.prop('disabled', false);
                    this.$blockNewsletterSignup.removeClass(SPINNER_MODIFIER);
                    $message.html(data.message);
                    $message.addClass(MESSAGE_SHOW_MODIFIER);
                    if (data.error) {
                        this.$blockNewsletterSignup.addClass(HAS_ERROR_MODIFIER);
                    }
                    setTimeout(function() {
                        $message.removeClass(MESSAGE_SHOW_MODIFIER);
                    }, 3000);
                }.bind(this));
            }
        }.bind(this));
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/accelerator/assets/scripts/src/App/Mailchimp/MailchimpHandler.js